export const SET_LOYALTY_USER = 'app/loyalty/SET_LOYALTY_USER';
export const SET_LOYALTY_SPEND = 'app/loyalty/SET_LOYALTY_SPEND';
